import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sortByKeyAndReturnValues'
})
export class SortByKeyAndReturnValuesPipe implements PipeTransform {

	transform(options: KeyValue<number, string>[], localeId: string): string[] {
		return options
			.sort((a, b) => {
				// Sort by key, and if the keys are the same (which is not expected), sort by values using locale id.
				if (a.key !== b.key) {
					return a.key - b.key;
				}
				return a.value.localeCompare(b.value, localeId);
			})
			.map(option => option.value);	
	}
}
